function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import {Dialog as MaterialDialog} from "../../../../__snowpack__/pkg/@mui/material.js";
import MaterialBox from "../../../../__snowpack__/pkg/@mui/material/Box.js";
import MaterialDialogContent from "../../../../__snowpack__/pkg/@mui/material/DialogContent.js";
import MaterialTypography from "../../../../__snowpack__/pkg/@mui/material/Typography.js";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {getRandomString} from "../../../common/generic-react.functions.js";
import Draggable from "../../atoms/draggable/draggable.component.js";
import Icon from "../../atoms/icon/icon.component.js";
import {BoxContainer, DialogActionsContainer, DialogTitleContainer} from "./alert-dialog.styles.js";
function AlertDialog({
  open,
  disableEscapeKeyDown,
  disableBackdropClick = false,
  content,
  actions,
  title,
  fullWidth,
  maxWidth,
  fullScreen,
  draggable,
  onBackdropClick,
  onClose,
  showCloseIcon = false
}) {
  const [openState, setOpenState] = useState(open);
  useEffect(() => {
    setOpenState(open);
  }, [open]);
  const titleId = useMemo(() => `title-id_${getRandomString()}`, []);
  const descriptionId = useMemo(() => `description-id_${getRandomString()}`, []);
  const handleClose = useCallback((event, reason) => {
    if (reason === "backdropClick" && disableBackdropClick || reason === "escapeKeyDown" && disableBackdropClick) {
      return;
    }
    setOpenState(false);
    if (onClose) {
      onClose(event, reason);
    }
  }, [onClose, disableBackdropClick]);
  const handleBackdropClick = useCallback((e) => {
    if (disableBackdropClick) {
      return;
    }
    setOpenState(false);
    if (onBackdropClick) {
      onBackdropClick(e);
    }
  }, [onBackdropClick, disableBackdropClick]);
  const paperComponentFn = useCallback((props) => /* @__PURE__ */ React.createElement(Draggable, _extends({}, props, {
    handleSelector: `#${titleId}`,
    cancelSelector: "[class*='MuiDialogContent-root']"
  })), [titleId]);
  const PaperComponent = useMemo(() => !draggable ? void 0 : paperComponentFn, [draggable, paperComponentFn]);
  return /* @__PURE__ */ React.createElement(MaterialDialog, {
    open: openState,
    onClose: handleClose,
    onBackdropClick: handleBackdropClick,
    disableEscapeKeyDown,
    fullWidth,
    fullScreen,
    maxWidth,
    PaperComponent,
    "aria-labelledby": titleId,
    "aria-describedby": descriptionId
  }, /* @__PURE__ */ React.createElement(DialogTitleContainer, {
    move: draggable,
    id: titleId
  }, /* @__PURE__ */ React.createElement(BoxContainer, null, /* @__PURE__ */ React.createElement(MaterialTypography, {
    paddingX: 3,
    paddingY: 2,
    variant: "h6"
  }, title), showCloseIcon && /* @__PURE__ */ React.createElement(Icon, {
    onClick: onClose
  }, "close"))), /* @__PURE__ */ React.createElement(MaterialDialogContent, null, /* @__PURE__ */ React.createElement(MaterialBox, {
    marginTop: 1,
    id: descriptionId
  }, content)), /* @__PURE__ */ React.createElement(DialogActionsContainer, null, actions));
}
export default /* @__PURE__ */ React.memo(AlertDialog);
